import React from "react";
import ChrWidgetActions from "../PageUI/Basic/Widget/ChrWidgetActions";
import * as ArrayExtensions from "../../../utils/CoreExtensions/ArrayExtensions";

export const getActionsBasedOnPosition = (actions) => {
  const { left: leftActions, right: rightActions } = actions;
  return {
    leftActions: <ChrWidgetActions actions={ leftActions } />,
    rightActions: <ChrWidgetActions actions={ rightActions } />,
  };
};

export const anyPositionBasedActionPresent = (actions) => {
  const { left: leftActions, right: rightActions } = actions;
  return anyActionPresent(leftActions) || anyActionPresent(rightActions);
}

const anyActionPresent = (actions) => {
  return actions && (ArrayExtensions.isPresent(actions.pinned) || ArrayExtensions.isPresent(actions.notPinned));
}
